meedy.controller('meedy.mainController', ['$scope', '$rootScope', '$state', '$injector', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', '$mdSidenav', '$mdUtil', '$translate', 'meedy.authModel',
    function($scope, $rootScope, $state, $injector, objectHelper, applicationModel, userModel, $mdSidenav, $mdUtil, $translate, authModel) {

        function setData() {
            $scope.applicationItems = $scope.bindData(function() { return applicationModel.applicationItems }, 'applicationItems', $scope);
            $scope.menuItems = $scope.bindData(function() { return applicationModel.menuItems }, 'menuItems', $scope);
            $scope.sideBarItems = $scope.bindData(function() { return applicationModel.sideBarItems }, 'sideBarItems', $scope);
            $scope.breadcrumbItems = $scope.bindData(function() { return applicationModel.breadcrumbItems }, 'breadcrumbItems', $scope);
            $scope.titleBar = $scope.bindData(function () { return applicationModel.titleBar }, 'titleBar', $scope);

            $scope.slidePanelState = $scope.bindData(function() { return applicationModel.slidePanelState }, 'slidePanelState', $scope);

            $scope.currentUser = $scope.bindData(function() { return userModel.currentUser }, 'currentUser', $scope);

            $scope.dataLoading = false;

            $scope.toggleLeft = buildToggler('left');

            /**
             * Build handler to open/close a SideNav; when animation finishes
             * report completion in console
             */
            function buildToggler(navID) {
                var debounceFn =  $mdUtil.debounce(function(){
                    $mdSidenav(navID)
                        .toggle()
                        .then(function () {
                        });
                },200);
                return debounceFn;
            }

            $scope.payments = [];
            $scope.subscriptions = [];
        }

        function setListeners() {
            $scope.bindChange(function() { return userModel.currentUser }, function onCurrentUserChange(newValue, oldValue, scope) {
                var loggedUser = newValue;
                if (loggedUser) {
                    $translate.use(userModel.selectedLanguage ? userModel.selectedLanguage : 'pl_PL');
                    applicationModel.isLoggedIn = true;

                }
            }, $scope);

            $scope.$on('$destroy', function (event) {
                $scope.unbind($scope);
            });

            $scope.toggleSidenav = function(menuId) {
                $mdSidenav(menuId).toggle();
            };

            $scope.$on(Event.MEEDY.USER.GET_LOGGED_USER.SUCCESS, function(event, loggedUser) {
                $translate.use(userModel.selectedLanguage ? userModel.selectedLanguage : 'pl_PL');
                applicationModel.isLoggedIn = true;

            });
        }

        function setActions() {
            $scope.logout = function () {
                authModel.invalidate();
            };

            $scope.changePassword = function() {
                $state.go(Constant.STATE.APP.MEEDY.ACCOUNT.CHANGE_PASSWORD);
            };

            $scope.helpPage = function() {
				$state.go(Constant.STATE.APP.MEEDY.HELP.MOVIES);
				
                // var win = window.open('https://www.meedydoctors.pl/pomoc', '_blank');
                // win.focus();
            }
        }

        function initialize() {
            if(!userModel.currentUser) {
                userModel.getLoggedUser();
            }
        }

        setData();
        setListeners();
        setActions();
        initialize();






    }
]);
